export default __webpack_public_path__ + "static/media/contextual-traits.c1942659.png";